// extracted by mini-css-extract-plugin
export default {"title":"BlockTitle_title__sxZj6","subtitle":"BlockTitle_subtitle__NJOVa"};